module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), (_vm.cxt.isFilterMode()) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll"
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.filteredItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "to": '/chats/' + item.id
      }
    }, [_c('v-card-title', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.lastCount > 0),
        expression: "item.lastCount > 0"
      }],
      attrs: {
        "right": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.lastCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getItemTitle(item)))])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.lastCount === 0),
        expression: "item.lastCount === 0"
      }]
    }, [_vm._v(_vm._s(_vm.getItemTitle(item)))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getItemLastTime(item)))])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getItemHTML(item))
      }
    })])], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb903c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/ChatList.vue
// module id = 1193
// module chunks = 1